import { render, staticRenderFns } from "./StoreEditViewAccordo.vue?vue&type=template&id=b54500d4&scoped=true"
import script from "./StoreEditViewAccordo.vue?vue&type=script&lang=js"
export * from "./StoreEditViewAccordo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54500d4",
  null
  
)

export default component.exports